/**
 * Buy-me-a-coffee: Text-Link (zuverlässig ohne externes Bild).
 * Position: Eltern-Container (z. B. .app-page-gutter-bmc-slot) setzt die Platzierung.
 */

import React from 'react';

import { BUY_ME_A_COFFEE_TOOLTIP, BUY_ME_A_COFFEE_URL } from '@/utils/constants';

const BuyMeACoffeeButton: React.FC = () => (
  <span className="app-bmc-wrap">
    <a
      href={BUY_ME_A_COFFEE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="app-bmc-button app-bmc-button-text"
      aria-label={BUY_ME_A_COFFEE_TOOLTIP}
    >
      <span className="app-bmc-fallback">☕ Buy me a coffee</span>
    </a>
    <span className="app-bmc-tooltip" aria-hidden="true">
      {BUY_ME_A_COFFEE_TOOLTIP}
    </span>
  </span>
);

export default BuyMeACoffeeButton;
